class DefaultFoe {
  Name = "";
  Rank = "Troublesome";
  Source = {
    Name: "User",
    Page: "n/a",
  };
  Features = ["", "", "", ""];
  Drives = ["", "", "", ""];
  Tactics = ["", "", "", ""];
  Description = "";
  Quest = "";
  id = "";
  Type = "Ironlanders";
  core = false;
  front = true;
  Tags = [];
  icon = "perspective-dice-six-faces-random";
}
export default DefaultFoe;
